import React, { Component } from 'react';
import { Button, Card, Form, message } from 'antd';
import { browserHistory } from 'react-router';
import moment from 'moment';
import { BackBtn } from '@comm/BackBtn';
import { queryDeleteTermination, querySaveTermination } from '@api/incubator/termination';
import FlowOp from '@comm/workflow/submitOp';
import { queryBusinessInfo } from '@api/common/business';
import TablePayable from './TablePayable';
import PayableStatic from './PayableStatic';
import CardBase from '../detail/StationBase';
import FormCheck from './FormCheck';
import FormTime from './FormTime';
import './end.less';

class PageEnd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
      payables: [],
      payableStatic: {},
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const { data } = this.props;
    this.files = [];
    if (data && data.files) {
      this.files = data.files;
    }
    this.businessInfo();
  }

  /** 合同详情 */
  businessInfo = () => {
    const data = this.props.data || {};
    queryBusinessInfo({
      businessUuid: this.props.params.uuid || data.business.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        // 过滤掉申请终止合同签订已经完成的退款
        (res.data.payables || []).forEach(item => {
          item.refund = 0;
        });

        if (data && data.payables) {
          res.data.payables.map(item => this.initPayablesEdit(item));
          this.handlePayableChange(res.data.payables);
        }
        this.setState({
          dataInfo: res.data,
          payables: res.data.payables,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  handleDelete = uuid => {
    queryDeleteTermination({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.replace(`/incubator/termination_manage`);
      } else {
        message.error(res.message);
      }
    });
  };

  terminationSave = params => {
    this.setState({
      submiting: true,
    });
    querySaveTermination(params).then(res => {
      this.setState({
        submiting: false,
      });
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.replace(`/incubator/termination_manage`);
      } else {
        message.error(res.message);
      }
    });
  };

  /** 太过复杂需要优化 */
  // 组合合同详情与终止详情，显示最终的终止详情相关账单
  initPayablesEdit = payableItem => {
    const {
      data: { payables },
    } = this.props;
    payables.forEach(item => {
      if (item.liquidate && payableItem.type === 0) {
        this.liquidateUuid = item.liquidate.uuid;
        payableItem.damages = item.liquidate.price;
      }
      if (item.terms.length > 0) {
        if (item.no === payableItem.payableNo) {
          payableItem.refund = 0;
          payableItem.obsolete = 0;
          item.terms.forEach(item1 => {
            if (item1.payType === 1) {
              payableItem.obsoleteUuid = item1.uuid;
              payableItem.obsolete += item1.price;
            }
            if (item1.payType === 2 && item1.status === 0) {
              payableItem.refundUuid = item1.uuid;
              payableItem.refund += item1.price;
            }
          });
        }
      }
    });
  };

  handlePayableChange = params => {
    const payableStatic = { refund: 0, obsolete: 0, damages: 0 };
    params.forEach(item => {
      payableStatic.refund += +item.refund || 0;
      payableStatic.obsolete += +item.obsolete || 0;
      payableStatic.damages += +item.damages || 0;
    });
    this.setState({
      payables: params,
      payableStatic,
    });
  };

  getPayables = () => {
    const { payables } = this.state;
    let formatPayables = [];
    payables.forEach(item => {
      const item2 = {};
      item2.payableUuid = item.uuid;
      item2.beginDate = item.beginDate;
      item2.endDate = item.endDate;
      item2.date = item.date;
      item2.type = item.type;
      if (item.refund) {
        formatPayables = formatPayables.concat([{ ...item2, payType: 2, price: item.refund }]);
      }
      if (item.obsolete) {
        formatPayables = formatPayables.concat([{ ...item2, payType: 1, price: item.obsolete }]);
      }
      if (item.damages) {
        this.liquidate = {
          price: item.damages,
          payableUuid: item.uuid,
          uuid: this.liquidateUuid,
        };
      }
    });
    return formatPayables;
  };

  handleChooseFile = params => {
    this.files = params;
    this.setState({
      showFileTips: params.length === 0,
    });
  };

  validateFile = () => {
    if (!this.files.length) {
      message.warn('没有选择附件！');
      this.setState({
        showFileTips: true,
      });
      return false;
    }
    return true;
  };

  submit = op => e => {
    const { data } = this.props;
    const { dataInfo } = this.state;
    if (e) {
      e.preventDefault();
    }
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (!this.validateFile()) {
          return;
        }
        if (data) {
          values.uuid = data.uuid;
        }
        const params = {
          ...values,
          businessUuid: dataInfo.businessUuid,
          beginDate: moment(values.beginDate).format('YYYY-MM-DD'),
          endDate: moment(values.endDate).format('YYYY-MM-DD'),
          ...this.state.payableStatic,
          payables: this.getPayables(),
          liquidate: this.liquidate || {},
          reason: values.reason,
          files: this.files || data.files,
          type: dataInfo.businessStatus.type, // 1异常终止
        };
        if (op === 'audit') {
          this.terminationSave(params);
        } else {
          message.warn('保存草稿功能正在开发，敬请期待！');
        }
      }
    });
  };

  render() {
    const { dataInfo, payables, payableStatic, showFileTips, submiting } = this.state;
    const { data } = this.props;
    return (
      <Form>
        <div style={{ marginBottom: 15 }}>
          <BackBtn />
          <FlowOp handleClick={this.submit} loading={submiting} />
          {data && data.uuid ? (
            <Button
              icon="delete"
              style={{ marginRight: 10 }}
              onClick={() => this.handleDelete(data.uuid)}
            >
              删除
            </Button>
          ) : null}
        </div>
        <CardBase dataInfo={dataInfo} {...this.props} type="termition" />
        <Card title="终止条款" className="mb16">
          <FormTime {...this.props} dataInfo={dataInfo} />
          <TablePayable data={payables} onChange={this.handlePayableChange} />
          <PayableStatic data={payableStatic} />
        </Card>
        <FormCheck
          {...this.props}
          customUuid={dataInfo.customUuid}
          handleChooseFile={this.handleChooseFile}
          showFileTips={showFileTips}
        />
      </Form>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(PageEnd);



// WEBPACK FOOTER //
// ./src/components/incubator/contract/end/PageEnd.js